import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileEntity } from 'src/app/core';
import { DocumentService } from 'src/app/shared';

@Component({
  selector: 'app-admin-unconfirm-shared-file',
  templateUrl: './admin-unconfirm-shared-file.component.html',
  styleUrls: ['./admin-unconfirm-shared-file.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminUnconfirmSharedFileComponent implements OnInit {
  constructor(
    private documentService: DocumentService,
    private reference: MatDialogRef<AdminUnconfirmSharedFileComponent>,
    @Inject(MAT_DIALOG_DATA) private file: FileEntity
  ) {}
  ngOnInit(): void {}

  /**
   * unconfirm the file.
   */
  public unconfirm(reason: string) {
    this.documentService.unconfirm(this.file.id, reason).subscribe((data) => {
      this.reference.close(data);
    });
  }
}
